import { round } from 'mathjs';

export const DECIMALREGEX = /,|\./g;
export const THOUSANDSREGEX = /\B(?=(\d{3})+(?!\d))/g;
const SCIENTIFICREGEX = /\.([0-9]*[1-9])?0*/g;

export const applyTwoDecimals = (numberAsStr: string, decimal: string, grouping: string): string => {
    const number = parseFloat(numberAsStr);
    const formatted = roundTwoDecimals(number);
    return formatted.replace(DECIMALREGEX, decimal).replace(THOUSANDSREGEX, grouping);
};

export const roundTwoDecimals = (number: number): string => {
    const rounded = round(number, 2);
    return rounded.toFixed(2);
};

export const applyScientific = (number: number, decimal: string, exponential: number): string =>
    number.toExponential(exponential).replace(SCIENTIFICREGEX, '.$1').replace(DECIMALREGEX, decimal);

export const removeDecimalsAndApplySeparator = (number: number, grouping: string): string =>
    Math.floor(number).toString().replace(THOUSANDSREGEX, grouping);
